export function initMainMenu(){

    function initInnerSubMenuLogic() {
        const isDesktop = () => window.innerWidth > 991;

        document.querySelectorAll<HTMLElement>('.menu-item_sub').forEach(sub => {
            const triggers = sub.querySelectorAll<HTMLElement>('.menu-item_sub-trigger[data-id]');

            if (!triggers.length) return;

            triggers.forEach(trigger => {
                trigger.addEventListener('click', (e) => {
                    if (!isDesktop()) return;

                    e.preventDefault();
                    e.stopPropagation();

                    const id = trigger.getAttribute('data-id');
                    if (!id) return;

                    const isActive = trigger.classList.contains('active');

                    const allTriggers = sub.querySelectorAll<HTMLElement>('.menu-item_sub-trigger');
                    const allTargets = sub.querySelectorAll<HTMLElement>('[data-menu-id]');

                    // снимаем всё внутри текущего menu-item_sub
                    allTriggers.forEach(t => t.classList.remove('active'));
                    allTargets.forEach(t => t.classList.remove('active'));

                    // если кликнули по активному → просто выключили и выходим
                    if (isActive) return;

                    // активируем новый
                    trigger.classList.add('active');

                    const target = sub.querySelector<HTMLElement>(`[data-menu-id="${id}"]`);
                    if (target) {
                        target.classList.add('active');
                    }
                });
            });
        });

        // при ресайзе ниже 991 — сбрасываем
        window.addEventListener('resize', () => {
            if (isDesktop()) return;

            document
                .querySelectorAll('.menu-item_sub-trigger.active, [data-menu-id].active')
                .forEach(el => el.classList.remove('active'));
        });
    }

    function positionSubMenus() {
        const menuLinks = document.querySelectorAll<HTMLAnchorElement>('.menu-link[data-menu]');
        const isDesktop = window.innerWidth > 991;

        menuLinks.forEach(link => {
            const key = link.getAttribute('data-menu');
            if (!key) return;

            const sub = document.querySelector<HTMLElement>(`.menu-item_sub[data-main-menu="${key}"]`);
            if (!sub) return;

            if (!isDesktop) {
                sub.style.position = '';
                sub.style.top = '';
                sub.style.left = '';
                sub.style.right = '';
                sub.classList.remove('menu-item_sub-right');
                return;
            }

            const linkRect = link.getBoundingClientRect();

            sub.style.position = 'absolute';
            sub.style.top = `${window.scrollY + linkRect.bottom + 30}px`;

            // --- если submenu скрыт, временно делаем видимым для расчёта ---
            const wasHidden = window.getComputedStyle(sub).display === 'none';
            if (wasHidden) {
                sub.style.visibility = 'hidden';
                sub.style.display = 'block';
            }

            // сначала позиционируем слева от кнопки
            sub.style.left = `${window.scrollX + linkRect.left}px`;
            sub.style.right = '';

            const subRect = sub.getBoundingClientRect();
            const viewportWidth = window.innerWidth;

            // если выходит за правый край
            if (subRect.right > viewportWidth) {
                // вычисляем right относительно правого края кнопки
                const right = viewportWidth - (window.scrollX + linkRect.right);
                sub.style.left = '';
                sub.style.right = `${right}px`;
                sub.classList.add('menu-item_sub-right');
            } else {
                sub.style.left = `${window.scrollX + linkRect.left}px`;
                sub.style.right = '';
                sub.classList.remove('menu-item_sub-right');
            }

            // вернуть исходное состояние, если был скрыт
            if (wasHidden) {
                sub.style.display = '';
                sub.style.visibility = '';
            }
        });
    }


    function initMenuLogic() {
        const body = document.body;
        const menuLinks = document.querySelectorAll<HTMLAnchorElement>('.menu-link[data-menu]');
        const subs = document.querySelectorAll<HTMLElement>('.menu-item_sub[data-main-menu]');

        if (!menuLinks.length || !subs.length) return;

        const isDesktop = () => window.innerWidth > 991;

        function deactivateAll() {
            subs.forEach(s => s.classList.remove('active'));
            body.classList.remove('menu-show');
        }

        menuLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                if (!isDesktop()) return;

                e.preventDefault();
                e.stopPropagation();

                const key = link.getAttribute('data-menu');
                if (!key) return;

                const current = document.querySelector<HTMLElement>(
                    `.menu-item_sub[data-main-menu="${key}"]`
                );
                if (!current) return;

                const isActive = current.classList.contains('active');

                if (isActive) {
                    deactivateAll();
                    return;
                }

                subs.forEach(s => s.classList.remove('active'));
                current.classList.add('active');

                body.classList.add('menu-show');

                // на всякий случай перепозиционируем при клике
                positionSubMenus();
            });
        });

        document.addEventListener('click', (e) => {
            if (!isDesktop()) return;

            const target = e.target as HTMLElement;

            const active = document.querySelector('.menu-item_sub.active') as HTMLElement | null;
            if (!active) return;

            const clickedInside = active.contains(target);
            const clickedMenuLink = target.closest('.menu-link[data-menu]');

            if (!clickedInside && !clickedMenuLink) {
                deactivateAll();
            }
        });

        window.addEventListener('resize', () => {
            positionSubMenus();
            if (!isDesktop()) deactivateAll();
        });
    }
    window.addEventListener('load', () => {
        positionSubMenus();
        initMenuLogic();
        initInnerSubMenuLogic();
    });
}